import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-cooked-bread/react-cooked-bread/packages/docs/src/components/layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "provider",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#provider",
        "aria-label": "provider permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Provider`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`ToastProvider`}</inlineCode>{` controls the pop-up overlay, some common settings, and the state for our toasts. Add the toast provider to a top-level position in your app. All consumers must be descendants of the provider.`}</p>
    <pre {...{
      "className": "language-tsx"
    }}><code parentName="pre" {...{
        "className": "language-tsx"
      }}><span parentName="code" {...{
          "className": "token keyword"
        }}>{`import`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`DefaultToastRoot`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`DefaultToastContent`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`from`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'react-cooked-bread'`}</span>{`

`}<span parentName="code" {...{
          "className": "token keyword"
        }}>{`const`}</span>{` `}<span parentName="code" {...{
          "className": "token function-variable function"
        }}><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`App`}</span></span>{` `}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span>{`
  `}<span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastProvider`}</span>{`
    toastRoot`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`DefaultToastRoot`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{` `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// Required`}</span>{`
    toastContent`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`DefaultToastContent`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{` `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// Recommended, unless you customize \`DefaultToastRoot\``}</span>{`
  `}<span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
    `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span><span parentName="code" {...{
          "className": "token comment"
        }}>{`/* ... */`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
  `}<span parentName="code" {...{
          "className": "token tag"
        }}><span parentName="span" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`</`}</span><span parentName="span" {...{
              "className": "token class-name"
            }}>{`ToastProvider`}</span></span><span parentName="span" {...{
            "className": "token punctuation"
          }}>{`>`}</span></span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{`
`}</code></pre>
    <p>{`You can choose to either use default components we've created (and more components to choose from soon!) or you can add your own.`}</p>
    <Note mdxType="Note">
  <p>
    You must pass a component to <code>toastRoot</code> and you should provide a component to{' '}
    <code>toastContent</code>.
  </p>
    </Note>
    <p>{`We give you the responsibility to add the components to the provider. This way, if you prefer custom components, you don't have to include unused code.`}</p>
    <p>{`Remember, the provider should wrap any components that need to consume or create toasts.`}</p>
    <h2 {...{
      "id": "props",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#props",
        "aria-label": "props permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Props`}</h2>
    <h3 {...{
      "id": "prop-descriptions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#prop-descriptions",
        "aria-label": "prop descriptions permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Prop descriptions`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`toastRoot`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Toast wrapper, this animates transitions with `}<inlineCode parentName="td">{`React-Transition-Group`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`toastContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Inner toast content, includes icons, close button, text and colors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`*`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`container`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ToastContainer`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wrapper component that places the toasts fixed in the viewport`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`autoDismiss`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A global default whether new toasts should dismiss by a timer (`}<inlineCode parentName="td">{`addToast`}</inlineCode>{` may override)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`timeout`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`5000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A global default for how long a toast with `}<inlineCode parentName="td">{`autoDismiss`}</inlineCode>{` should persist in milliseconds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`maxToasts`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The maximum number of toasts that should be in the queue at a given time, new toasts push old toasts out when this value is set`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`placement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#placement"
            }}>{`Placement`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bottom-right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Where in the viewport the container should place the toasts`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`transitionDuration`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TransitionDuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{appear: 200, exit: 200}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Transition timeout object or number for `}<inlineCode parentName="td">{`React-Transition-Group`}</inlineCode>{` transition element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`reverseColumn`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reverses the toast item flex column container, typically good for when toasts are placed at the bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pauseAllOnHover`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If all toasts should pause when mouse moves over any of the toasts`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pauseOnFocusLoss`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If all toasts should pause when browser window loses focus, is minimized or the user switches to another tab`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`containerStyles`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/react-cooked-bread/extend#stylers"
            }}>{`Styler`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`container CSS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Override styles for container element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`transitionGroupStyles`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/react-cooked-bread/extend#stylers"
            }}>{`Styler`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`transition group CSS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Override styles for `}<inlineCode parentName="td">{`TransitionGroup`}</inlineCode>{` wrapper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`toastRootStyles`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/react-cooked-bread/extend#stylers"
            }}>{`Styler`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`toast root CSS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Override styles for toast React Transition Group animation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`toastContentStyles`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/react-cooked-bread/extend#stylers"
            }}>{`Styler`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`toast content CSS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Override styles for toast elements`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <small>
  *Not required, but <strong>strongly recommended</strong>
    </small>
    <h3 {...{
      "id": "placement",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#placement",
        "aria-label": "placement permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Placement`}</h3>
    <p><inlineCode parentName="p">{`bottom-left`}</inlineCode>{`, `}<inlineCode parentName="p">{`bottom-center`}</inlineCode>{`, `}<inlineCode parentName="p">{`bottom-right`}</inlineCode>{`, `}<inlineCode parentName="p">{`top-left`}</inlineCode>{`, `}<inlineCode parentName="p">{`top-center`}</inlineCode>{`, `}<inlineCode parentName="p">{`top-right`}</inlineCode></p>
    <h3 {...{
      "id": "stylers",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#stylers",
        "aria-label": "stylers permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Stylers`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "/react-cooked-bread/extend#stylers"
      }}>{`how to use a styler`}</a>{`. With stylers, you can either pass in a style object or a function to dynamically change the styles based on the component state.`}</p>
    <h3 {...{
      "id": "typescript",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#typescript",
        "aria-label": "typescript permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`TypeScript`}</h3>
    <pre {...{
      "className": "language-ts"
    }}><code parentName="pre" {...{
        "className": "language-ts"
      }}><span parentName="code" {...{
          "className": "token keyword"
        }}>{`interface`}</span>{` `}<span parentName="code" {...{
          "className": "token class-name"
        }}>{`ToastProviderValueProps`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
  toastRoot`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ComponentType`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastRootProps`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
  toastContent`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ComponentType`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastContentProps`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
  container`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`React`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span><span parentName="code" {...{
          "className": "token property-access"
        }}><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`ComponentType`}</span></span><span parentName="code" {...{
          "className": "token operator"
        }}>{`<`}</span><span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ContainerProps`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`>`}</span>{`
  containerStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ContainerStyler`}</span>{`
  transitionGroupStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionGroupStyler`}</span>{`
  toastRootStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastRootStyler`}</span>{`
  toastContentStyles`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`ToastContentStyles`}</span>{`
  autoDismiss`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  timeout`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`number`}</span>{`
  placement`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`PlacementOption`}</span>{`
  transitionDuration`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token maybe-class-name"
        }}>{`TransitionDuration`}</span>{`
  pauseAllOnHover`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  reverseColumn`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  pauseOnFocusLoss`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`boolean`}</span>{`
  maxToasts`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`?`}</span><span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token builtin"
        }}>{`number`}</span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span>{`
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      